// Etiquetas en español para valores enum usados en dropdowns y badges.
export const BOOKING = {
  lead: "Cliente potencial",
  interested: "Interesado",
  deposit_pending: "Depósito pendiente",
  deposit_paid: "Depósito pagado",
  confirmed: "Confirmado",
  partial_paid: "Pago parcial",
  fully_paid: "Pago completo",
  cancelled: "Cancelado",
  refunded: "Reembolsado",
  waitlist: "Lista de espera",
};

export const TOUR_STATUS = {
  confirmed: "Confirmado",
  full: "Completado",
  in_progress: "En curso",
  finished: "Finalizado",
  cancelled: "Cancelado",
};

export const ROOM_TYPE = {
  single: "Simple",
  double: "Doble",
  twin: "Twin",
  triple: "Triple",
  quad: "Cuádruple",
  quintuple: "Quíntuple",
  suite: "Suite",
  apartment: "Apartamento",
};

export const ACC_STATUS = {
  draft: "Pendiente",
  in_progress: "Reservado",
  confirmed: "Reservado y pagado",
  cancelled: "Cancelado",
};

export const TRANSPORT_STATUS = ACC_STATUS;

export const PAY_METHOD = {
  stripe: "Stripe",
  transfer: "Transferencia",
  cash: "Efectivo",
  card: "Tarjeta",
  paypal: "PayPal",
  other: "Otro",
};

export const PAY_KIND = {
  deposit: "Depósito",
  second: "Segundo pago",
  final: "Pago final",
  extra: "Extra",
  refund: "Reembolso",
};

export const EXP_CATEGORY = {
  accommodation: "Alojamiento",
  vehicles: "Vehículos",
  fuel: "Combustible",
  food: "Comida",
  flights: "Vuelos",
  guides: "Guías",
  per_diem: "Dietas",
  permits: "Permisos",
  activities: "Actividades",
  marketing: "Marketing",
  commissions: "Comisiones",
  stripe: "Stripe",
  insurance: "Seguros",
  unexpected: "Imprevistos",
  other: "Otros",
};

export const PROVIDER_CATEGORY = {
  hotel: "Hotel",
  transport: "Transporte",
  guide: "Guía",
  restaurant: "Restaurante",
  agency: "Agencia",
  driver: "Conductor",
  activity: "Actividad",
  location: "Localización",
  other: "Otro",
};

export const TASK_PRIORITY = {
  low: "Baja",
  medium: "Media",
  high: "Alta",
  urgent: "Urgente",
};

export const TASK_STATUS = {
  todo: "Pendiente",
  doing: "En curso",
  done: "Hecho",
};

export const DOC_CATEGORY = {
  passport: "Pasaporte",
  insurance: "Seguro",
  contract: "Contrato",
  hotel: "Hotel",
  transport: "Transporte",
  invoice: "Factura",
  receipt: "Recibo",
  ticket: "Billete",
  permit: "Permiso",
  waiver: "Exención",
  list: "Lista",
  other: "Otro",
};

export const label = (map, key, fallback = "") => (map && key in map ? map[key] : (fallback || key));
